<template>
  <DashboardPage>
    <CompanyWasteCode :id="route.params.id" />
  </DashboardPage>
</template>

<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue';

import CompanyWasteCode from './components/CompanyWasteCode.vue';
const route = useRoute()
</script>